<template>
  <div class="page-content almacen-page">
    <div class="almacen-wrapper">
      <div class="almacen-card">
        <!-- Header -->
        <header class="entrada-header">
          <div>
            <p class="almacen-title">Órdenes de entrada a almacén</p>
            <p class="almacen-subtitle">
              Consulta las órdenes de entrada registradas y accede al detalle para impresión.
            </p>
          </div>

          <div class="entrada-header__actions no-print">
            <button
              type="button"
              class="ios-primary-button"
              @click="irANuevaOrden"
            >
              + Agregar orden almacén
            </button>
          </div>
        </header>

        <section class="entrada-lista">
          <!-- LOADING -->
          <div v-if="cargando" class="estado-centrado">
            <div class="spinner"></div>
            <p>Cargando órdenes de entrada…</p>
          </div>

          <!-- ERROR -->
          <div v-else-if="error" class="estado-centrado estado-error">
            <p>{{ error }}</p>
          </div>

          <!-- VACÍO -->
          <div v-else-if="!ordenes.length" class="estado-centrado">
            <p>Aún no hay órdenes de entrada registradas.</p>
          </div>

          <!-- TABLA -->
          <div v-else class="entrada-table">
            <div class="entrada-table-header">
              <span class="entrada-col entrada-col--fecha">Fecha</span>
              <span class="entrada-col entrada-col--folio">Folio</span>
              <span class="entrada-col entrada-col--proveedor">Proveedor</span>
              <span class="entrada-col entrada-col--personas">Solicitó / Entregó / Recibió</span>
              <span class="entrada-col entrada-col--items">Items</span>
              <span class="entrada-col entrada-col--items">Unidades</span>
              <span class="entrada-col entrada-col--acciones no-print">Acciones</span>
            </div>

            <div
              v-for="orden in ordenes"
              :key="orden.id_orden_entrada"
              class="entrada-table-row"
            >
              <span class="entrada-col entrada-col--fecha">
                {{ formatearFecha(orden.fecha) }}
              </span>

              <span class="entrada-col entrada-col--folio">
                {{ orden.folio || '—' }}
              </span>

              <span class="entrada-col entrada-col--proveedor">
                {{ orden.proveedor || 'Sin proveedor' }}
              </span>

              <span class="entrada-col entrada-col--personas">
                <span class="entrada-personas">
                  <span v-if="orden.solicito"><strong>S:</strong> {{ orden.solicito }}</span>
                  <span v-if="orden.entrego"><strong>E:</strong> {{ orden.entrego }}</span>
                  <span v-if="orden.recibio"><strong>R:</strong> {{ orden.recibio }}</span>
                </span>
              </span>

              <span class="entrada-col entrada-col--items">
                {{ orden.total_items }}
              </span>

              <span class="entrada-col entrada-col--items">
                {{ orden.total_unidades }}
              </span>

              <span class="entrada-col entrada-col--acciones no-print">
                <button
                  type="button"
                  class="entrada-accion-btn"
                  @click="verOrden(orden)"
                >
                  👁 Ver
                </button>
              </span>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DashboardOrdenesEntrada',
  data() {
    return {
      ordenes: [],
      cargando: false,
      error: null,
    };
  },
  mounted() {
    this.cargarOrdenes();
  },
  methods: {
    async cargarOrdenes() {
      this.cargando = true;
      this.error = null;
      try {
        const res = await axios.get('/api/almacen/ordenes-entrada/listar');
        if (res.data?.status === 'ok' && Array.isArray(res.data.ordenes)) {
          this.ordenes = res.data.ordenes;
        } else {
          this.ordenes = [];
        }
      } catch (error) {
        console.error('Error al cargar órdenes de entrada:', error);
        this.$toast?.error('No se pudieron cargar las órdenes de entrada.');
        this.error =
          error.response?.data?.message ||
          error.message ||
          'No se pudieron cargar las órdenes de entrada.';
        this.ordenes = [];
      } finally {
        this.cargando = false;
      }
    },
    formatearFecha(f) {
      if (!f) return '—';
      // asume formato YYYY-MM-DD
      const [y, m, d] = f.split('-');
      if (!y || !m || !d) return f;
      return `${d}/${m}/${y}`;
    },
    irANuevaOrden() {
      this.$router.push('/dashboard/crear-orden-entrada');
    },
    verOrden(orden) {
      this.$router.push(`/dashboard/ver-orden-entrada/${orden.id_orden_entrada}`);
      // this.$router.push({
      //   name: 'VerOrdenEntrada',
      //   params: { id: orden.id_orden_entrada },
      // });
    },
  },
};
</script>

<style scoped>
.almacen-page {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
}

.almacen-wrapper {
  width: 100%;
  max-width: 1100px;
}

.almacen-card {
  border-radius: 1.8rem;
  padding: 1.5rem 1.4rem 1.2rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.96)
    );
  backdrop-filter: blur(24px);
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.9),
    0 0 0 1px rgba(15, 23, 42, 0.85);
}

.almacen-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #e5e7eb;
}

.almacen-subtitle {
  font-size: 0.8rem;
  color: #94a3b8;
}

/* Header */
.entrada-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1.1rem;
}

.entrada-header__actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

/* Lista contenedor */
.entrada-lista {
  border-radius: 1.25rem;
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: rgba(15, 23, 42, 0.92);
  padding: 0.7rem 0.7rem 0.6rem;
}

/* Hints */
.entrada-hint {
  font-size: 0.8rem;
  color: #94a3b8;
}

/* Tabla-like */
.entrada-table {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.entrada-table-header,
.entrada-table-row {
  display: grid;
  grid-template-columns: 110px 110px 1.4fr 1.6fr 80px 90px 90px;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
}

.entrada-table-header {
  padding: 0.2rem 0.35rem 0.35rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.4);
  color: #cbd5f5;
}

.entrada-table-row {
  padding: 0.35rem 0.35rem;
  border-radius: 0.9rem;
  background: rgba(15, 23, 42, 0.96);
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.entrada-col {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.entrada-personas {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.entrada-accion-btn {
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.8);
  background: radial-gradient(
    circle at top left,
    rgba(30, 41, 59, 0.96),
    rgba(15, 23, 42, 0.98)
  );
  color: #e5e7eb;
  font-size: 0.75rem;
  padding: 0.25rem 0.7rem;
  cursor: pointer;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    transform 0.08s ease,
    box-shadow 0.16s ease;
}

.entrada-accion-btn:hover {
  transform: translateY(-0.5px);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.9);
}

/* Botones iOS */
.ios-primary-button {
  border-radius: 999px;
  padding: 0.45rem 1rem;
  font-size: 0.8rem;
  border: 1px solid transparent;
  cursor: pointer;
  background: radial-gradient(
    circle at 0 0,
    rgba(129, 140, 248, 0.7),
    rgba(37, 99, 235, 1)
  );
  border-color: rgba(129, 140, 248, 0.9);
  color: #e5e7eb;
  box-shadow: 0 14px 32px rgba(37, 99, 235, 0.7);
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    transform 0.08s ease,
    box-shadow 0.16s ease;
}

.ios-primary-button:hover {
  transform: translateY(-0.5px);
  box-shadow: 0 18px 38px rgba(37, 99, 235, 0.9);
}

/* ESTADOS CENTRADOS + SPINNER */
.estado-centrado {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
  justify-content: center;
  color: #a5b0de;
  font-size: 0.9rem;
}

.estado-error {
  color: #ff9ca6;
}

.spinner {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 3px solid rgba(115, 145, 255, 0.25);
  border-top-color: rgba(132, 165, 255, 0.95);
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 900px) {
  .entrada-table-header,
  .entrada-table-row {
    grid-template-columns: 90px 90px 1.2fr 1.2fr 70px 70px;
  }

  .entrada-col--acciones {
    display: none;
  }
}

@media (max-width: 768px) {
  .entrada-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .entrada-table-header {
    display: none;
  }

  .entrada-table-row {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;
    row-gap: 0.2rem;
    font-size: 0.78rem;
  }

  .entrada-col--fecha {
    grid-column: 1 / 2;
  }

  .entrada-col--folio {
    grid-column: 2 / 3;
    text-align: right;
  }

  .entrada-col--proveedor {
    grid-column: 1 / 3;
  }

  .entrada-col--personas {
    grid-column: 1 / 3;
  }

  .entrada-col--items,
  .entrada-col--acciones {
    grid-column: auto;
  }
}

/* Print */
@media print {
  .no-print {
    display: none !important;
  }

  .almacen-card {
    box-shadow: none;
    border: none;
    background: #ffffff;
    color: #000000;
  }
}
</style>
